// removed by extract-text-webpack-plugin
module.exports = {"base":"_1NXIa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tooltip/Tooltip.scss
// module id = 1783
// module chunks = 0